export default {
  lighterGrey: '#F0F0F0',
  lightGrey: '#CCCED0',
  paleGrey: '#B5BBC0',
  midGrey: '#838B93',
  deepGrey: '#687078',
  darkGrey: '#505558',
  charcoalGrey: '#2C3135',
  background: '#F7F7F7',
  pureWhite: '#FFFFFF',
  offWhite: '#FBFDFE',
  offBlack: '#060400',

  primary: '#FCA311',
  secondary: '#FCA311',
  tertiary: '#CCCED0',

  negative: '#FF3A47',
  warning: '#FDD430',
  success: '#00D689',

  consumption: '#92BEE2',
  production: '#99DBD8',
  self_consumption: '#4E67C1',
  total_battery: '#AC99DB',
  self_consumption_battery: '#AC99DB',
  soc_battery: '#6E4EC1',
  production_to_battery: '#8D73CE',
  savings: '#D7C06A',
  revenues: '#AD922E',
  cost_1: '#AD922E',
  cost_2: '#D7C06A',
  from_shared: '#2E74AD',
  to_shared: '#39A29D',
  total_shared: '#73CEAB',
  total_grid: '#BFE8C4',
  from_grid: '#6AA6D7',
  to_grid: '#73CEC9',
};
